import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
// import './static/css/jVectorMap.css';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();


serviceWorker.register();

// import React from 'react';
// import ReactDOM from 'react-dom';
// import App from './App';
// // import './static/css/jVectorMap.css';
// import * as serviceWorker from './serviceWorker';
// import 'antd/dist/antd.less';  // or antd/dist/antd.css if not using less
//
// // ✅ Handle chunk load errors gracefully
// // This reloads the page if a user has a stale cached version
// window.addEventListener("error", (e) => {
//     if (e?.message && e.message.includes("Loading chunk")) {
//         console.warn("Chunk load error detected, reloading app...");
//         window.location.reload();
//     }
// });
//
// // Render the main App
// ReactDOM.render(<App />, document.getElementById('root'));
//
// // If you want your app to work offline and load faster,
// // change unregister() to register(). But beware of caching issues.
// serviceWorker.unregister();

